import { useTranslation } from "react-i18next";
import { Flex, Text, Image, Spinner } from "@chakra-ui/react";
import { H2 } from "src/atoms/typography";
import imageSrc from "./warning-circular.svg";
import getStrings from "./getStrings";

export default function ErrorMode({
  error,
  monitoringStatusBar,
  isInDetachMode
}) {
  const { t } = useTranslation();
  const { heading, text } = getStrings(t, error);

  return (
    <Flex
      justifyContent="start"
      alignItems="center"
      flexDirection="column"
      width="100%"
      zIndex="100"
      position="absolute"
      top="38px"
      height="calc(100% - 38px)"
    >
      <Flex
        width="100%"
        flexDirection="column"
        alignItems="center"
        bg="warningBase"
        pt="12px"
        px="14px"
        flex="1 1 auto"
      >
        {monitoringStatusBar}
        <Flex
          width="320px"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          flex="1 1 auto"
        >
          <Image
            width={isInDetachMode ? "30vmin" : "104px"}
            src={imageSrc}
            {...(isInDetachMode && {
              "@media (max-height: 140px)": {
                width: "32px",
                height: "32px"
              }
            })}
          />
          <H2
            fontSize={isInDetachMode ? "6.9vmin" : [20, 30, 40]}
            lineHeight={isInDetachMode ? "8.7vmin" : [1.27, 1.31, "normal"]}
            letterSpacing={["0.3px", "0.4px", "0.6px"]}
            color="white"
            mt={isInDetachMode ? "8px" : "16px"}
            textAlign="center"
            {...(isInDetachMode && {
              mb: "8px",
              maxWidth: "90vw",
              sx: {
                "@media (max-height: 140px)": {
                  fontSize: "10px !important",
                  lineHeight: "1.1 !important"
                }
              }
            })}
          >
            {heading}
          </H2>
          {!isInDetachMode && (
            <Text
              mt="8px"
              mb="32px"
              color="white70"
              fontSize={["12px", "18px", "24px"]}
              lineHeight="1.67"
              letterSpacing="0.15px"
              textAlign="center"
            >
              {text}
            </Text>
          )}
          {!isInDetachMode && <Spinner color="white" />}
        </Flex>
      </Flex>
    </Flex>
  );
}
